export const ja = 'true';
export const nei = 'false';
export const han = '1';
export const hun = '2';
